import { required } from 'utilities';
import { OOHDisplayTypeField } from './OOHDispalyTypeField';
import { DecimalField, IntField, TextField, useField } from '@ff-it/form';
import { OOHDisplayType } from './types';

function DynamicFields({ name = '' }: { name?: string }) {
  const {
    input: { value },
  } = useField<OOHDisplayType | null>(`${name}display_type`, { allowNull: true, subscription: { value: true } });

  if (value !== 'DIGITAL' && value !== 'HYBRID') {
    return null;
  }
  return (
    <div className="form-row">
      <IntField name={`${name}loop_length_sec`} label="Loop length (sec.)" className="col-md-3" />
      <IntField name={`${name}spot_length_sec`} label="Spot length (sec.)" className="col-md-3" />
      <IntField name={`${name}spots_per_loop`} label="Spots per loop" className="col-md-3" />
    </div>
  );
}

export function OOHFormatForm({ name = '' }: { name?: string }) {
  return (
    <>
      <div className="form-row">
        <OOHDisplayTypeField
          name={`${name}display_type`}
          label="Display type"
          className="col-md-3"
          required
          validate={required}
        />
        <IntField name={`${name}quantity`} label="Quantity (faces)" className="col-md-3" />
        <TextField name={`${name}dimensions`} label="Dimensions (WxH)" className="col-md-3" />
        <TextField name={`${name}area`} label="Area of surface" className="col-md-3" />
      </div>
      <div className="form-row">
        <TextField name={`${name}url`} label="URL" className="col-md-4" />
        <TextField
          name={`${name}market_dma`}
          label="Market DMA"
          className="col-md-4"
          help="Designated market area or city"
        />
        <TextField
          name={`${name}audience_data`}
          label="Audience data"
          className="col-md-4"
          help="Est. imp. per unit (e.g., weekly), reach etc."
        />
      </div>
      <div className="form-row">
        <DecimalField name={`${name}lat`} label="Latitude" className="col-md-3" />
        <DecimalField name={`${name}lon`} label="Longitude" className="col-md-3" />
      </div>
      <DynamicFields name={name} />
    </>
  );
}
